// extracted by mini-css-extract-plugin
export var highlight = "highlight-module--highlight--a3876";
export var highlightContent = "highlight-module--highlightContent--d9358";
export var mobileImage = "highlight-module--mobileImage--9c85e";